<h2 mat-dialog-title>Edit Mapping: {{ location.title }}</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>City</label>
        <input type="text" class="form-control" [(ngModel)]="location.mapping.city" placeholder="Enter city">
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label>WP URL Path</label>
        <input type="text" class="form-control" [(ngModel)]="location.mapping.urlPathWp" placeholder="Enter path (e.g. /my-location)">
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Service</label>
        <input type="text" class="form-control" [(ngModel)]="location.mapping.service" placeholder="Optional">
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Industry</label>
        <input type="text" class="form-control" [(ngModel)]="location.mapping.industry" placeholder="Optional">
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label>Status</label>
        <select class="form-control" [(ngModel)]="location.status">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-secondary btn-sm" (click)="close()">Cancel</button>
  <button class="btn btn-primary btn-sm ms-2" (click)="save()">Save Changes</button>
</mat-dialog-actions>
